import BoxInfo from '@/components/boxInfo/boxInfo';
import EmptyMessage from '@/components/emptyMessage';
import Header from '@/core/components/header/header';
import ICONS from '@/shared/entities/constants/icons';
import React from 'react';

export const LEAD_INDICATION_PAGE_TITLE = 'Vitta por Assinatura';
export const LEAD_INDICATION_PAGE_DESCRIPTION =
  'Consulte o histórico de indicações de leads enviadas.';

const History: React.FC = () => (
  <>
    <Header
      title={LEAD_INDICATION_PAGE_TITLE}
      description={LEAD_INDICATION_PAGE_DESCRIPTION}
      icon={ICONS.LEAD_INDICATION}
    />

    <BoxInfo padding={24}>
      <div aria-label='Histórico de indicações' data-testid='lead-indication-history-container'>
        <EmptyMessage
          vertical
          title='Histórico de indicações'
          description='A listagem de indicações será exibida neste espaço.'
        />
      </div>
    </BoxInfo>
  </>
);

export default History;
